import {
  parseSelectedDay,
  parseWeekStart,
} from '@versita/shared/timetable-utils';
import { DateTime } from 'luxon';
import { TimetableState } from '@versita/frontend/timetable-state';

/**
 * Returns the period label based on the current view mode of the calendar.
 */
export const usePeriodLabel = (cal: TimetableState): string => {
  const getPeriodLabel = {
    WEEK: getWeekPeriodLabel,
    DAY: getDayPeriodLabel,
  }[cal.viewMode];
  return getPeriodLabel(cal);
};

/**
 * Returns a formatted date string representing the currently selected day
 */
function getDayPeriodLabel(cal: TimetableState): string {
  if (!cal.selectedDay) {
    console.error('Selected day is undefined');
    // continue anyway and let it break in a less dramatic way than throwing (by
    // falling back to the current day instead)
  }
  const day = cal.selectedDay
    ? parseSelectedDay(cal.selectedDay)
    : DateTime.now();
  return day.toFormat('DDDD');
}

/**
 * Returns a formatted date string representing the currently selected week
 */
function getWeekPeriodLabel(cal: TimetableState): string {
  const start = parseWeekStart(cal.timetableWeekStart);
  const end = start.plus({ days: 6 });
  return `${start.toFormat('d MMM')}-${end.toFormat('d MMM, yyyy')}`;
}
